// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2upn6","list":"styles_list__36ZHx","disableSelection":"styles_disableSelection__1Inc7"};